import axios from "axios";

import { ApiService } from "../../servicios/api.service";
import LocalStorageKeys from "../../data/localStorageKeys";

export class ComentarioApi {
  static endPoint = "comentario/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Token " + localStorage.getItem(LocalStorageKeys.token);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static approveByComercioIdAndUsuarioId(comercioId, usuarioId) {
    return axios.put(
      this.BasePath + comercioId + "/" + usuarioId + "/aprobar",
      {},
      this.Config
    );
  }

  static countWithFilter(filter) {
    return axios.post(
      this.BasePath + "aprobado/cantidad/filtro",
      filter,
      this.Config
    );
  }

  static countPendingWithFilter(filter) {
    return axios.post(
      this.BasePath + "pendiente/cantidad/filtro",
      filter,
      this.Config
    );
  }

  static deleteByComercioIdAndUsuarioId(comercioId, usuarioId) {
    return axios.delete(
      this.BasePath + comercioId + "/" + usuarioId,
      this.Config
    );
  }

  static getListWithFilter(filter) {
    return axios.post(this.BasePath + "aprobado/filtro", filter, this.Config);
  }

  static getPendingListWithFilter(filter) {
    return axios.post(this.BasePath + "pendiente/filtro", filter, this.Config);
  }

  static rejectByComercioIdAndUsuarioId(comercioId, usuarioId) {
    return axios.put(
      this.BasePath + comercioId + "/" + usuarioId + "/rechazar",
      {},
      this.Config
    );
  }
}
